import { OwnedAssistanceProduct } from '@/interfaces';
import {
  RSA_RACQ_EVERYDAY_LITE,
  RSA_RACQ_EVERYDAY,
  RSA_RACQ_EVERYDAY_PLUS,
  RSA_RACQ_ULTRA_CARE,
  RoadsideProductType,
  RSA_ROADSIDE_EXCESS_USE,
  RSA_RACQ_ULTIMATE_CARE,
  RSA_ARN005,
  RSA_ARN006,
  RSA_ARN007,
  RSA_RACQ_RV,
} from '../roadside-helpers';
import { ApttusDirectDebitStatus } from '@/interfaces/entities/apttus-direct-debit-status-response.interface';

const autoPaymentEnabled = (policy: OwnedAssistanceProduct): boolean => {
  return policy?.isAutoPayment === true;
};

const autoPaymentDisabled = (policy: OwnedAssistanceProduct): boolean => {
  return !policy?.isAutoPayment;
};

const paymentConnected = (policy: OwnedAssistanceProduct, directDebitStatus: ApttusDirectDebitStatus): boolean => {
  return directDebitStatus === ApttusDirectDebitStatus.Current;
};

const paymentDisconnected = (policy: OwnedAssistanceProduct): boolean => {
  return !policy?.isAutoPayment;
};

const hasNominatedVehicle = (policy: OwnedAssistanceProduct): boolean => {
  return policy?.hasVehicle === true;
};

const noNominatedVehicle = (policy: OwnedAssistanceProduct): boolean => {
  return !policy?.hasVehicle;
};

const isExcessProductCoverLevel = (policy: OwnedAssistanceProduct): boolean => {
  return policy.productCode === RSA_ROADSIDE_EXCESS_USE;
};

const isNotExcessProductCoverLevel = (policy: OwnedAssistanceProduct): boolean => {
  return (
    !!policy?.tierId &&
    ((policy.roadsidePolicyType === RoadsideProductType.Standard &&
      [
        RSA_RACQ_EVERYDAY_LITE,
        RSA_RACQ_EVERYDAY,
        RSA_RACQ_EVERYDAY_PLUS,
        RSA_RACQ_ULTRA_CARE,
        RSA_RACQ_ULTIMATE_CARE,
        RSA_RACQ_RV,
      ].includes(policy.tierId)) ||
      policy.roadsidePolicyType === RoadsideProductType.Cmo ||
      (!!policy?.productCode && [RSA_ARN005, RSA_ARN006, RSA_ARN007].includes(policy.productCode)))
  );
};

export const RSADisplayRules = {
  autoPaymentEnabled,
  autoPaymentDisabled,
  paymentConnected,
  paymentDisconnected,
  hasNominatedVehicle,
  noNominatedVehicle,
  isExcessProductCoverLevel,
  isNotExcessProductCoverLevel,
};
